import React, { useEffect } from "react";
import { getTransactionDetail, refundTransaction } from '../../../slices/transactions'
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Link } from "react-router-dom";
import { TransactionStatus } from "../../../components/status";
import { SvgReceipt, SvgRepay, SvgArrow, SvgCardDots } from "../../../components/svg";
import { Button } from "../../../components/button";
import { Receipt } from "../../../components/receipt";
import moment from 'moment';
import { formatMoney, getDate } from "../../../utils";
import PaymentMethod from "../../../components/payment-method";
import { CustomerDetailsCard } from "../../../components/customer_details_card";

const translations = [
    gettext('Single Transaction'),
    gettext('Transaction id'),
    gettext('Date/time'),
    gettext('Amount'),
    gettext('Payment processor transaction ID'),
    gettext('Refund'),
    gettext('Receipt'),
    gettext('Payment method'),
    gettext('Subscription'),
    gettext('Subscription'),
    gettext('Valid until'),
    gettext('Amount'),
    gettext('Receipt from payment processor'),
    gettext('Response from payment processor'),
    gettext('Refund response from payment processor'),
]

const TransactionDetail = () => {

    const dispatch = useDispatch()
    const selectedTransaction = useSelector((state) => state.transactions.selectedTransaction)
    const loadingDetail = useSelector((state) => state.transactions.loadingDetail)
    let { transactionId } = useParams();

    const initializeRefund = () => {
        dispatch(refundTransaction({ transactionId: transactionId }))
    }

    return (
        <>
            {selectedTransaction &&
                <>
                    {loadingDetail ?
                        <div className="loader top-50 start-50 position-absolute" role="status"></div>
                        :
                        <>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col px-0">
                                        <h1 className="title">{gettext('Single Transaction')}</h1>
                                    </div>
                                </div>
                            </div>
                            <div className="contentarea">
                                <div className="container-fluid detail">
                                    <div className="row">
                                        <div className="col-12 mb-4">
                                            <TransactionStatus transaction={selectedTransaction} showText={true} />
                                        </div>
                                    </div>
                                    <div className="row mb-4">
                                        <div className="col-5 mb-3">
                                            <label>{gettext('Transaction id')}</label>
                                            <p>{selectedTransaction.uuid}</p>
                                        </div>
                                        <div className="col-4 mb-3">
                                            <label>{gettext('Date/time')}</label>
                                            <p>{getDate(selectedTransaction.created_at, true)}</p>
                                        </div>
                                        <div className="col-3 mb-3 text-end">
                                            <label>{gettext('Amount')}</label>
                                            <p>{selectedTransaction.currency} {formatMoney(selectedTransaction.amount)}</p>
                                        </div>
                                        {selectedTransaction.fail_code && 
                                            <div className="col-12 mb-4">
                                                <div className="alert border-red">
                                                    <TransactionStatus transaction={selectedTransaction} showText={false} />
                                                    <span className="ms-2 valign-middle">{selectedTransaction.fail_code_verbose?.message}</span>
                                                    <span className="ms-2 valign-middle">{selectedTransaction.fail_code_verbose?.solve_message}</span>
                                                </div>
                                            </div>
                                        }
                                        <div className="col-12 mb-3">
                                            <hr />
                                        </div>
                                    </div>
                                    {selectedTransaction.state === 'settled' &&
                                        <div className="row">
                                            <div className="col-6 mb-4">
                                                <label>{gettext('Payment processor transaction ID')}</label>
                                                <p>{selectedTransaction.id}</p>
                                            </div>
                                            <div className="col-3 mb-4">
                                                <Button variant={"secondary"} formControl={true} icon={<SvgRepay />} onClick={initializeRefund}>{gettext('Refund')}</Button>
                                            </div>
                                            <div className="col-3 mb-4">
                                                <a href={`/apiv2/transactions/${selectedTransaction.id}/receipt/`} target="_blank">
                                                    <Button variant={"secondary"} formControl={true} icon={<SvgReceipt />} >{gettext('Receipt')} <span>(PDF)</span></Button>
                                                </a>
                                            </div>
                                        </div>
                                    }
                                    {selectedTransaction.payment_method &&
                                        <div className="row">
                                            <div className="col mb-4">
                                                <h2>{gettext('Payment method')}</h2>
                                                <PaymentMethod paymentMethod={selectedTransaction.payment_method} />
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="container-fluid related">
                                    {selectedTransaction.subscription &&
                                        <>
                                            <div className="row">
                                                <div className="col mb-4">
                                                    <h2>{gettext('Customer')}</h2>
                                                    <CustomerDetailsCard customer={selectedTransaction.subscription.customer} />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col mb-4">
                                                    <h2>{gettext('Subscription')}</h2>
                                                    <div className="card mb-3">
                                                        <div className="row">
                                                            <div className="col-4 p-4 pe-lg-0">
                                                                <label>{gettext('Subscription')}</label>
                                                                <p className="text-nowrap overflow-hidden">{selectedTransaction.subscription.plan.name}</p>
                                                            </div>
                                                            <div className="col-3 p-4">
                                                                <label>{gettext('Valid until')}</label>
                                                                <p>{selectedTransaction.subscription.active_until}</p>
                                                            </div>
                                                            <div className="col-3 p-4">
                                                                <label>{gettext('Amount')}</label>
                                                                <p>{selectedTransaction.subscription.currency} {formatMoney(selectedTransaction.subscription.amount)}</p>
                                                            </div>
                                                            <div className="col-2 align-self-stretch d-flex align-items-center justify-content-center ps-0 arrow-divider">
                                                                <Link to={`/subscriptions/${selectedTransaction.subscription.id}`} className="d-flex align-items-center justify-content-center w-100 h-100"><SvgArrow /></Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    }
                                    {selectedTransaction.state === 'settled' &&
                                        <div className="row">
                                            <div className="col mb-4">
                                                <h2>{gettext('Receipt from payment processor')}</h2>
                                                <div className="receipt-wrapper">
                                                    <Receipt transaction={selectedTransaction} />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {selectedTransaction.state !== 'pending' &&
                                        <div className="row">
                                            <div className="col">
                                                <h2>{gettext('Response from payment processor')}</h2>
                                                {selectedTransaction?.data.receipt &&
                                                    <div className="">
                                                        <pre>{JSON.stringify(selectedTransaction?.data.receipt, undefined, 4)}</pre>
                                                    </div>
                                                }
                                                {selectedTransaction?.data.refund_receipt &&
                                                    <>
                                                        <h2>{gettext('Refund response from payment processor')}</h2>
                                                        <div className="">
                                                            <pre>{JSON.stringify(selectedTransaction?.data.refund_receipt, undefined, 4)}</pre>
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </>
                    }
                </>
            }
        </>
    )

}

export default TransactionDetail